var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTtime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z",
    stroke: "#7F8983",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0078 10.508C11.61 10.508 11.2285 10.666 10.9472 10.9473C10.6658 11.2286 10.5078 11.6102 10.5078 12.008C10.5078 12.4058 10.6658 12.7874 10.9472 13.0687C11.2285 13.35 11.61 13.508 12.0078 13.508C12.4056 13.508 12.7872 13.35 13.0685 13.0687C13.3498 12.7874 13.5078 12.4058 13.5078 12.008C13.5078 11.6102 13.3498 11.2286 13.0685 10.9473C12.7872 10.666 12.4056 10.508 12.0078 10.508ZM12.0078 10.508V7M15.0148 15.02L13.0658 13.072",
    stroke: "#7F8983",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtime);
export default __webpack_public_path__ + "static/media/ttime.fad4d43320e0ed4827929a24994d6117.svg";
export { ForwardRef as ReactComponent };